import { useTranslation } from 'react-i18next';

import { OrgMemberWithProfile } from '@/features/org/api/get-org-members';
import { DefaultMemberInvitationList } from '@/features/projects/create-project/components/default-member-invitation-list';
import { ProjectMemberInvitationList } from '@/features/projects/create-project/components/project-member-invitation-list';
import { usePaywall } from '@/features/subscriptions/hooks/use-paywall';
import PlusIcon from '@/shared/assets/plus-white.svg?react';
import { FlowBackButton } from '@/shared/components/flow/flow-actions';
import { FlowHeaderOptional } from '@/shared/components/flow/flow-fields';
import { Button } from '@/shared/components/ui/button';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/shared/components/ui/card';

export interface CreateProjectInvitationOverviewFormProps {
  memberIdsToInvite: string[];
  orgMembers: OrgMemberWithProfile[];
  onAddMore: () => void;
  onBack: () => void;
  onSubmitAll: () => void;
  handleRemove: (email: string) => void;
}

export const CreateProjectInvitationOverviewForm = ({
  memberIdsToInvite,
  orgMembers,
  onBack,
  onSubmitAll,
  handleRemove,
}: CreateProjectInvitationOverviewFormProps) => {
  const { t } = useTranslation('project', {
    keyPrefix: 'InviteUsersForm',
  });
  const { t: shared_t } = useTranslation('project', {
    keyPrefix: 'Shared',
  });
  const { t: common_t } = useTranslation('common');
  const { openProjectPaywall } = usePaywall();

  return (
    <Card variant="form" wrapWithStars>
      <CardHeader>
        <FlowHeaderOptional />
        <CardTitle>{t('invitation_overview_title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-6">
          <DefaultMemberInvitationList />

          {memberIdsToInvite.length > 0 && (
            <ProjectMemberInvitationList
              memberIdsToInvite={memberIdsToInvite}
              orgMembers={orgMembers}
              onRemove={handleRemove}
            />
          )}

          <Button
            variant="outline"
            onClick={() => openProjectPaywall()}
            btnType="secondary"
            className="self-end bg-custom-soft-purple text-white"
            gradientBorder="whiteToHalfWhite"
          >
            <PlusIcon className="h-[19px] w-[18px]" />
            {t('add_user_button')}
          </Button>
        </div>
      </CardContent>
      <CardFooter>
        <FlowBackButton onClick={onBack}>
          {shared_t('back_button_label')}
        </FlowBackButton>
        <Button
          type="button"
          variant="greenGradient"
          btnType="primary"
          onClick={onSubmitAll}
          className="w-40"
        >
          {common_t('button.continue')}
        </Button>
      </CardFooter>
    </Card>
  );
};
